export enum NOTIFICATION_EMAIL_TEMPLATES {
  APPROVAL = "introducer_approval_notification",
  REAPPROVAL = "introducer_reapproval_notification",
}
